<script>
import Vue from 'vue'
import Swal from 'sweetalert2'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Portlet from '@src/components/portlet'
import AchievementsService from '@services/resources/AchievementsService'
import Money from '@src/mixins/money'
import ViewModel from '@components/marks/view'
import _ from 'lodash'

var service = AchievementsService.build()
/**
 * Dashboard-4 component
 */
export default {
  page: {
    title: 'Marcos Atingidos',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Portlet, ViewModel },
  mixins: [Money],
  data() {
    return {
      title: 'Marcos Atingidos',
      achievements: [],
      solicitation: {},
      loading: true,
      items: [
        {
          text: 'Início',
          href: '/',
        },
        {
          text: 'Marcos Atingidos',
          active: true,
        },
      ],
      totalRows: 10,
      currentPage: 1,
      total: 0,
      totalToPaid: 0,
      perPage: 15,
      pageOptions: [20, 50, 100],
      filter: '',
      filterOn: [],
      filters: {},
      sortBy: 'name',
      sortDesc: false,
      columns: [
        { key: 'id', label: 'ID', sortable: true },
        { key: '_date', label: 'Data', sortable: true },
        { key: '_marco', label: 'Marco', sortable: true },
        { key: '_seller', label: 'Vendedor', sortable: true },
        { key: 'amount', label: 'Valor Atingido', sortable: true },
      ]
    }
  },
  watch: {
    currentPage() {
      this.fetchAchievements()
    },
    perPage() {
      this.fetchAchievements()
    }
  },
  mounted() {
    this.fetchAchievements()
  },
  methods: {
    setColor(type) {
      if (type) {
        if (type === 'green') {
          return 'background: #00E4A0'
        }
        if (type === 'yellow') {
          return 'background: #fff700'
        }
        if (type === 'red') {
          return 'background: #FF0A44'
        }
        if (type === 'black') {
          return 'background: #000000'
        } 
      }else{
          return 'background:#c7c7c7;';
      }
    },
    fetchAchievements() {
      this.loading = true
      this.achievements = []

      let data = {
        page: this.currentPage,
      }

      service
        .search(data)
        .then((resp) => {
          this.achievements = resp.data
          this.currentPage = resp.current_page
          this.totalRows = resp.total
          this.total = resp.total
          this.perPage = resp.per_page
          this.loading = false
        })
        .catch((err) => {})
    },
  },
}
</script>
<template>
  <div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <div class="row">

          </div>

          <!-- Table -->
          <div class="row">
            <div class="col-12">
            
              <div
                v-if="achievements.length > 0 && !loading"
                class="table-responsive mb-0"
              >
                <b-table
                  :items="achievements"
                  :fields="columns"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                >

                  <template v-slot:cell(_date)="data">
                     {{ data.item.created_at  | datetime }}
                  </template>

                  <template v-slot:cell(_marco)="data">
                     {{ data.item.achievement.label }} 
                  </template>

                  <template v-slot:cell(_seller)="data">
                    <div class="externclass">
                      <div
                        class="classification"
                        :style="setColor(data.item.seller.classification)"
                      ></div>
                      <p>{{ data.item.seller.name }}</p>
                    </div>
                      <br>
                     {{ data.item.seller.email }}
                  </template>

                  <template v-slot:cell(amount)="data">
                    R$
                    {{ formatMoney(data.item.amount) }}
                  </template>

                </b-table>
              </div>
            </div>
          </div>

          <div v-if="achievements.length > 0" class="row">
                <div class="col">
                  <div
                    class="
                      dataTables_paginate
                      paging_simple_numbers
                      float-right
                    "
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="totalRows"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>

          <div v-if="loading" class="row justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div
            v-if="achievements.length == 0 && !loading"
            class="row justify-content-center"
          >
            <div class="alert alert-primary" role="alert">
              Sem requisições pendentes.
            </div>
          </div>
        </div>
        <!-- end card-box -->
      </div>
      <!-- end col -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.actions {
  gap: 5px;
  display: grid;
  grid-template-columns: 60px 60px;
}
</style>

